import { createSelector } from '@reduxjs/toolkit';

const selectAuth = (state) => state.auth || {};

export const selectAuthUser = createSelector(
  [selectAuth],
  (auth) => auth.user
);

export const selectAuthUserType = createSelector(
  [selectAuth],
  (auth) => auth.userType
);

export const selectIsAuthenticated = createSelector(
  [selectAuth],
  (auth) => !!auth.isAuthenticated
);

export const selectAuthToken = createSelector(
  [selectAuth],
  (auth) => auth.token
);
